import AuthService from 'services/AuthService'
import RoutesEnum from 'enums/routes.enum'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (AuthService.isLoggedIn()) {
                return next()
            }

            next({
                name: RoutesEnum.AUTH.LOGIN,
                query: { redirect: to.fullPath !== '/' ? to.fullPath : undefined },
            })
        })
    },
}
